/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import DbBaseObject from "@shared/DbBaseObject.js";


export const QuestionTypeEnum = Object.freeze({
	ONE_LINE: "one_line",
	MULTI_LINES: "multi_lines",
	RADIO_BUTTONS: "radio_buttons",
	CHECKBOXES: "checkboxes",
	FILE_UPLOAD: "file_upload",
})


export class EventQuestion extends DbBaseObject{

	title: string = "";
	type: string = "";
	isRequired: boolean = true;
	isEnabled: boolean = true;
	answer: string = "";


	constructor(title: string, type: string, isRequired: boolean, isEnabled: boolean) {
		super();
		this.title = title;
		this.type = type;
		this.isRequired = isRequired;
		this.isEnabled = isEnabled;
	}
}
